import './style';
import App from './components/app';
import SentryService from "./services/SentryService";

SentryService.init();
SentryService.registerSentryHandlers();

export default App;
